var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_968_20487)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.4529,
    cy: 50.5,
    r: 50.5,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4529,
    cy: 50.5,
    r: 49.5,
    stroke: "#FAFAFA",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4066 22.0169L28.051 35.5533V33.4177H22.4885V74.4669L18.8511 74.462L18.8777 74.9602H53.4211V74.4669H27.8769V49.2081H35.292V47.7231H41.643V49.2081H53.4211V22.0073L53.4066 22V22.0169ZM51.4161 38.944C51.4161 39.1883 51.2178 39.3866 50.9711 39.3866H45.9624C45.7182 39.3866 45.5198 39.1883 45.5198 38.944V35.1373C45.5198 34.8906 45.7182 34.6923 45.9624 34.6923H50.9711C51.2178 34.6923 51.4161 34.8906 51.4161 35.1373V38.944Z",
    fill: "#E8E7E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3706 74.4669V33.4177H78.8081V35.5533L53.4525 22.0169V22L53.4356 22.0073V49.2081H65.2161V47.7231H71.5671V49.2081H78.9822V74.4669H53.4356V74.9602H87.9814L88.008 74.462L84.3706 74.4669ZM61.6125 38.944C61.6125 39.1883 61.4142 39.3866 61.17 39.3866H55.888C55.6413 39.3866 55.443 39.1883 55.443 38.944V35.1373C55.443 34.8906 55.6413 34.6923 55.888 34.6923H61.17C61.4142 34.6923 61.6125 34.8906 61.6125 35.1373V38.944Z",
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 51.0553V49.2076H41.643V47.7227H35.292V49.2076H27.8769V74.4664H53.4211V72.6283H28.6V69.419H53.4211V68.038H28.6V64.8287H53.4211V63.4453H28.6V60.236H53.4211V58.855H28.6V55.6456H53.4211V54.2647H28.6V51.0553H36.1457V49.2076H40.7917V51.0553H53.4211Z",
    fill: "#172726"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9677 49.2076V74.4664H53.4211V72.6283H78.5179V69.419H53.4211V68.038H78.5179V64.8287H53.4211V63.4453H78.5179V60.236H53.4211V58.855H78.5179V55.6456H53.4211V54.2647H78.5179V51.0553H70.9722V49.2076H66.3262V51.0553H53.4211V49.2076H65.2016V47.7227H71.5526V49.2076H78.9677Z",
    fill: "#091010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 51.0567V54.2661H28.6V51.0567H36.1457V49.209H40.7917V51.0567H53.4211Z",
    fill: "#1C6C5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 55.6465H28.6V58.8558H53.4211V55.6465Z",
    fill: "#1C6C5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 60.2344H28.6V63.4437H53.4211V60.2344Z",
    fill: "#1C6C5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 64.8301H28.6V68.0394H53.4211V64.8301Z",
    fill: "#1C6C5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5178 51.0567V54.2661H53.4211V51.0567H66.3262V49.209H70.9721V51.0567H78.5178Z",
    fill: "#155045"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5178 55.6465H53.4211V58.8558H78.5178V55.6465Z",
    fill: "#155045"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5178 60.2344H53.4211V63.4437H78.5178V60.2344Z",
    fill: "#155045"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5178 64.8301H53.4211V68.0394H78.5178V64.8301Z",
    fill: "#155045"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5178 69.4199H53.4211V72.6293H78.5178V69.4199Z",
    fill: "#155045"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4211 69.4199H28.6V72.6293H53.4211V69.4199Z",
    fill: "#1C6C5E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_968_20487",
    x: 0.952942,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_968_20487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_968_20487",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage_icon.e4404879b638929b8aa34349000d779d.svg";
export { ForwardRef as ReactComponent };